import { useState, useRef, useEffect } from 'react'
import va from '@vercel/analytics'

import Price from '@components/Price/Price.jsx'
import LeftArrow from '@components/Icons/LeftArrow.jsx'
import RightArrow from '@components/Icons/RightArrow.jsx'
import StarSolid from '@components/Icons/StarSolid.jsx'
import StarHalf from '@components/Icons/StarHalf.jsx'
import QuickBuy from '@components/Collection/QuickBuy.jsx'
import OrganicTag from '@icons/OrganicTag.jsx'
import QuickBuyIcon from '@icons/QuickBuyIcon.jsx'
import RecommendedProduct from '@components/Product/RecommendedProduct'

import useHover from '@hooks/useHover.js'

import { splitLastOccurrence, convertToCurrency } from '@utils/utils.js'

const RecommendedCarousel = ({ carouselData }) => {
    const data = carouselData
    const elementRef = useRef()
    const [ref, isHovered] = useHover()

    //

    const [products, setProducts] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        const productsSlice = carouselData?.products?.slice(0, 12)
        setProducts(productsSlice)
        setIsLoading(false)
    }, [carouselData])

    const maxScrollWidth = useRef(0)
    const [currentIndex, setCurrentIndex] = useState(0)
    const carousel = useRef(null)
    const totalSlides = products.length
    const [scrollX, setScrollX] = useState(0)
    const [scrollEnd, setScrollEnd] = useState(false)

    let tileWidthClass = ''

    const movePrev = () => {
        if (carousel.current !== null) {
            let child
            let frameWidth = carousel.current.firstChild.offsetWidth

            let scrollFrame =
                Math.ceil(carousel.current.offsetWidth / frameWidth) - 1
            if (window.innerWidth > 800) {
                carousel.current.scrollLeft -= frameWidth * 3 + 12
            } else {
                carousel.current.scrollLeft -= frameWidth * 2 + 10
            }
            // setCurrentIndex((prevState) => prevState + 1)
        }
    }

    const moveNext = () => {
        if (carousel.current !== null) {
            let frameWidth = carousel.current.firstChild.offsetWidth

            let scrollFrame =
                Math.ceil(carousel.current.offsetWidth / frameWidth) - 1

            if (window.innerWidth > 800) {
                carousel.current.scrollLeft += frameWidth * 3 + 12
            } else {
                carousel.current.scrollLeft += frameWidth * 2 + 10
            }
        }
    }

    useEffect(() => {
        maxScrollWidth.current = carousel.current
            ? carousel.current.scrollWidth - carousel.current.offsetWidth
            : 0
    }, [])

    const scrollFunction = (e) => {
        setScrollX(carousel.current.scrollLeft)
        if (
            Math.floor(
                carousel.current.scrollWidth - carousel.current.scrollLeft
            ) <= carousel.current.offsetWidth
        ) {
            setScrollEnd(true)
        } else {
            setScrollEnd(false)
        }
    }

    //

    useEffect(() => {
        const loadBV = async () => {
            const scriptTag = document.createElement('script')
            scriptTag.async = true
            scriptTag.defer = true
            scriptTag.src =
                'https://apps.bazaarvoice.com/deployments/monicaandandy/main_site/production/en_US/bv.js'
            document.body.appendChild(scriptTag)
        }

        setTimeout(() => {
            loadBV()
            setTimeout(() => {
                const stars = document.querySelectorAll(
                    '.bv_stars_svg_no_wrap > svg'
                )
                stars.forEach((star) => {
                    star.style.width = '16px'
                    star.style.height = '16px'
                })
            }, 2000)
        }, 3000)
    }, [])

    return (
        <div className='carousel-outer max-w-[90vw] 2xl:max-w-[1400px] mx-auto'>
            <div className='carousel-inner wrap-[90vw] overflow-x-hidden lg:wrap-xl mx-auto'>
                <div className='carousel mx-auto wrap-[90vw] overflow-x-hidden lg:wrap-xl relative'>
                    <div className='carousel-header relative flex flex-col lg:flex-row lg:items-center mb-3 mr-4'>
                        <h2 className='text-lg md:text-xl lg:text-2xl'>
                            {data && data.title ? data.title : 'Best Sellers'}
                        </h2>
                        <div className='carousel-header-wrap lg:justify-end lg:ml-auto flex flex-col lg:flex-row items-center gap-3'>
                            <div className='shop-all-links flex items-center gap-3'>
                                <div className='shop-all-link'>
                                    {data && data.linkText ? (
                                        <a
                                            href={
                                                data && data.link
                                                    ? data.link
                                                    : '/collections/baby-clothes'
                                            }
                                            className='text-fl-sm underline lg:mr-3'
                                        >
                                            {data && data.linkText
                                                ? data.linkText
                                                : ''}
                                        </a>
                                    ) : null}
                                </div>
                            </div>

                            <div className='carousel-nav flex gap-3'>
                                <div
                                    className={`angle-left ${
                                        scrollX === 0
                                            ? 'cursor-not-allowed opacity-50'
                                            : 'cursor-pointer'
                                    }`}
                                    onClick={() => movePrev()}
                                    disabled={scrollX === 0}
                                >
                                    <LeftArrow width='w-[32px]' />
                                </div>
                                <div
                                    className={`angle-right ${
                                        scrollEnd
                                            ? 'cursor-not-allowed opacity-50'
                                            : 'cursor-pointer'
                                    }`}
                                    onClick={() => moveNext()}
                                    disabled={scrollEnd}
                                >
                                    <RightArrow width='w-[32px]' />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='relative overflow-x-hidden'>
                        <div
                            onScroll={(e) => scrollFunction(e)}
                            ref={carousel}
                            className='carousel-container relative grid grid-flow-col auto-cols-[minmax(50%,1fr)] lg:auto-cols-[minmax(230px,230px)] gap-1 overflow-x-scroll scroll-smooth snap-x snap-mandatory touch-pan z-0'
                        >
                            {products &&
                                products.map((item, index) => {
                                    return (
                                        <RecommendedProduct
                                            key={item.id}
                                            product={item}
                                            products={products}
                                            index={index}
                                        />
                                    )
                                })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RecommendedCarousel
